var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.sendToPreview.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("ValidationAlert", {
            attrs: { "error-list": _vm.errors.collect("server") },
          }),
          _vm._v(" "),
          _c("legend", [_vm._v("The Impact")]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.differenceMade,
                  expression: "formData.differenceMade",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "value-added",
                placeholder: "Enter a paragraph here...",
              },
              domProps: { value: _vm.formData.differenceMade },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "differenceMade", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "value-added" } },
              [_vm._v("(Optional) The value the User added to the project")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.testimonial,
                  expression: "formData.testimonial",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "testimonial",
                placeholder: "Enter a paragraph here...",
              },
              domProps: { value: _vm.formData.testimonial },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "testimonial", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "testimonial" } },
              [_vm._v("(Optional) Testimonial quote")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.testimonialPerson,
                  expression: "formData.testimonialPerson",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "testimonial-source",
                placeholder: "Enter the name of the testimonial person here...",
              },
              domProps: { value: _vm.formData.testimonialPerson },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.formData,
                    "testimonialPerson",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "testimonial-source" },
              },
              [_vm._v("(Optional) Testimonial source")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.back.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Back")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Save & Preview")]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }